import { DatePipe, formatDate } from "@angular/common";
import { Component, OnInit, QueryList, ViewChild, ViewChildren, OnDestroy, HostListener, ElementRef } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { CommonService } from "src/app/Service/Common.service";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { IDocSetModel, IPorjectInputModel } from "src/app/ViewModel/ScheduleDefinitionModel";
import { IScheduleDocInfo, IScheduleDocApprovalDetails, IScheduleDocApprovalDocId, IScheduleDocUploadStatusModel, IReviseScheduleDateDocModel, IScheduleDateUpdateDetails, IScheduleISODocUploadDetailsModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { BulkScheduleUploadComponent } from "../bulk_schedule_upload/bulk-schedule-upload.component";
import { ISODCIUploadComponent } from "../iso-dci-upload/iso-dci-upload.component";
import * as moment from 'moment';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { DataBindingDirective, GridDataResult, PageChangeEvent } from "@progress/kendo-angular-grid";
import { ScheduleExcelUploadComponent } from '../schedule-excel-upload/schedule-excel-upload.component';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { ScheduleEditComponent } from "../schedule-edit/schedule-edit.component";
import { ScheduleStartWorkflowComponent } from '../schedule-startworkflow/schedule-startworkflow.component';
import { ScheduleWorkflowhistoryComponent } from "../schedule-workflowhistory/schedule-workflowhistory.component";
import { IDocumentMailInputModel, IDocumentRevHistoryModel } from 'src/app/ViewModel/DocumentModel';
import { ScheduleDocumentMailListComponent } from '../schedule-document-mail-list/schedule-document-mail-list.component';
import { FileListComponent } from 'src/app/CommonComponents/file-list/file-list.component';
import { Align } from '@progress/kendo-angular-popup';
import { FileCompareComponent } from "src/app/CommonComponents/file-compare-component/file-compare.component";
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { CreateMessageComponent } from "../../communication/create-message/create-message.component";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { Module } from "src/app/Service/element-details.data.service";
import { DocumentService } from 'src/app/Service/document/document.service';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { ProjectViewModel } from "src/app/ViewModel/ProjectModel";
import { DciSupersedeComponent } from "../dci-supersede/dci-supersede.component";
import { FileUploadLibrary } from "src/app/Service/file/file.service";
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { TransmittalViewComponent } from "../../transmittal/transmittal-view/trasnsmittal-view.component";
import { ITransmittalDetailsModel, ITransmittalDocumentDetails, ITransmittalDocumentInput, ITransmittalMsgReceiverInput } from "src/app/ViewModel/TransmittalModel";
import { TransmittalMsgService } from "src/app/Service/transmittal/transmittal.service";

import { TransmittalService } from "src/app/Service/transmittal-template/transmittal-template.service";
import { TransmittalTemplateComponent } from 'src/app/Modules/transmittal/transmittal-template/transmittal-template.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { Observable } from 'rxjs/internal/Observable';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { saveAs } from 'file-saver';
import { BulkDCISupersedeComponent } from "../bulk-dci-supersede/bulk-dci-supersede.component";

interface INavigationTree {
    dedShortDesc?: string,
    dedDesc: string,
    documentSet?: IDocSetModel,
    items?: INavigationTree[]
}

@Component({
    selector: 'app-schedule-list',
    templateUrl: './schedule-list.component.html',
    styleUrls: ['./schedule-list.component.css']
})
export class ScheduleListComponent implements OnInit, OnDestroy {
    @ViewChild('schSearchForm') schSearchDynamicForm!: DynamicFormComponent;
    @ViewChild(DataBindingDirective) directive: any;
    @ViewChild('dciGrid') dciGrid: any;
    @ViewChild("docSetForm") dynamicForm: DynamicFormComponent;

    schSeachFieldsConfig: FieldConfig[] = [];
    enableFullscreen = false;
    enableRowWiseWFIcon = true;
    projectId!: number;
    groupId!: number;
    memberId!: number;
    projectCode!: string;
    hoverClass = '';
    public treeFilter: any;
    isSearch!: boolean;
    gridAllRevisionData: IScheduleDocInfo[] = [];
    gridAllData: IScheduleDocInfo[] = [];
    gridData: IScheduleDocInfo[] = [];
    gridView!: GridDataResult;
    gridLoadData: IScheduleDocInfo[] = [];
    docSetHierarchy: any[] = [];
    scheduleApprovalDocDetails: IScheduleDocApprovalDocId[] = [];
    reviseScheduleDateDetails: IReviseScheduleDateDocModel[] = [];
    SupercedeDCIDetails: IScheduleDocInfo[] = [];
    selectedDocSet: any;
    enableFilter = false;
    pageSize = 15;
    public skip = 0;
    lastViewingRecords = 30;
    lastViewingRecord: string = "30";
    IsShowSection = false;
    noOfDays = [30, 60, 90, 'All'];
    @ViewChildren('divIcon')
    divIconHover!: QueryList<any>;
    viewDciTabList: IScheduleDocInfo[] = [];
    viewSchDoc!: IScheduleDocInfo | null;
    selectedTabIndex: number = 0;
    selectedRootIndex: number = 0;
    public lastscrollLeft!: number;
    approvedCount: number = 0;
    rejectedCount: number = 0;
    holdedCount: number = 0;
    forActionCount: number = 0;
    inprogressCount: number = 0;
    completedCount: number = 0;
    totalCount: number = 0;
    isCanApprove: boolean = false;
    isCanReject: boolean = false;
    isShowWFIcon: boolean = false;
    isShowSupersedeIcon: boolean = false;
    public revHistory: IDocumentRevHistoryModel | null = null;
    public anchorElementPopup: any;
    public anchorAlignCenter: Align = { horizontal: 'center', vertical: 'bottom' };
    private anchorAlignLeft: Align = { horizontal: 'left', vertical: 'bottom' };
    private popupAlignLeft: Align = { horizontal: 'left', vertical: 'top' };
    public popupMargin = { horizontal: -15, vertical: 10 };
    public showRevHistory: boolean = false;
    isShowStartWF: boolean = false;
    isShowWFHistory: boolean = false;
    isShowEdit: boolean = false;
    isShowSuperEdit: boolean = false;
    isShowSupersede: boolean = false;
    isShowApprove: boolean = false;
    isLatest: boolean = true;
    IslatestShow: boolean = false;
    canUpload: boolean = false;
    canDelete: boolean = false;
    canView: boolean = false;
    is_File_Attached: boolean = false;
    public datevalue = new Date(this.getDateFormat());
    projectStaticElements: IProjectElementsOutput[] = [];
    isDocSetRequired: boolean = true;
    public RevisedScheduleDate: string = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
    colorCodes: any[] = ['#c57a7a', '#43ceab', '#33ae10', '#1579ab', '#e85342', '#5454E8'];
    @ViewChild('tabGroup') tabGroup: any;
    @ViewChild('excelDCIUpload') excelDCIUpload: any;
    @ViewChild('excelISOUpload') excelISOUpload: any;
    acceptFileTypes: string = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    stageColors: Map<string, string> = new Map<string, string>();
    private transmittalViewComponent!: TransmittalViewComponent;
    transmittalList: ITransmittalDetailsModel[] = [];
    transmittalCollection: any = [];
    viewTransmittalData!: TransmittalTemplateComponent | null;
    public projectName!: string;
    public ADSearchComponent: boolean = false;
    public ADSearchComponentdata = "search_dci";
    projectStartDate = new Date();
    projectEndDate = new Date();
    UnsubscribeArray: Subscription[] = [];
    public completeEditHide: boolean = true;
    public _isSuperEdit: boolean = true;

    public pageSizes = [15, 30, 50, 100, {
        text: 'All',
        value: 'all'
    }];
    public searchForm: FormGroup = new FormGroup({
        ctrlStageType: new FormControl(),
        ctrlDocType: new FormControl(),
        ctrlDocNo: new FormControl(),
        ctrlTransNo: new FormControl()
    });
    public Doc_type: any[] = [
        { value: '1', viewValue: 'DCI' },
        { value: '2', viewValue: 'Ext DCI' },
        { value: '3', viewValue: 'Std DCI' },
        { value: '4', viewValue: 'Vendor DCI' },
    ];
    public Doc_typeid!: any | null;
    public selectedTypeValue: string;
    public selectedTypeIndex: number = -1;
    public stageList: any[];
    public regConfig: FieldConfig[] = [];
    projectElements: IProjectElementsOutput[];
    searchTypeList: any = [];
    public start: any;
    public end: any;
    stages: any;
    @ViewChild('transmittalViewComponent') set content(content: TransmittalViewComponent) {
        if (content) { // initially setter gets called with undefined
            this.transmittalViewComponent = content;
        }
    }

    constructor(private dialog: MatDialog, private _scheduleDocService: ScheduleDocumentService, private loaderService: LoaderService,
        private _commonService: CommonService, private _scheDefService: ScheduleDefinitionService, public datepipe: DatePipe, private _notificationService: NotificationService,
        private encryptDecryptService: EncryptDecryptService, private _projInfoService: ProjectInfoService, private _docService: DocumentService, private _transmittalService: TransmittalMsgService, private transmittalService: TransmittalService
        , private elementRef: ElementRef) {
        this.allData = this.allData.bind(this);
    }

    ngOnInit(): void {
        let _projectDetails = this._commonService.getCurrentProjectDetails()
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.memberId = this._commonService.getLoggedInUserId();
        if (_projectDetails) {
            this.projectId = _projectDetails.projectId
            this.projectCode = _projectDetails.projectCode;
            this.projectName = _projectDetails.projectCode + ' - ' + _projectDetails.projectDescription;
            this.projectStartDate = (_projectDetails.startDate ? new Date(_projectDetails.startDate) : new Date());
            this.projectEndDate = (_projectDetails.endDate ? new Date(_projectDetails.endDate) : new Date());
        }
        this.loadAllStages();
        this.getProjectStaticElements();
        this.loadscheduleDocumnets();
        this.loadDocSetTree();
        this.enableMemberRoleFeatures();
        this.getDynamicForm();
        this.CheckMemberRoleFeatures();
    }

    CheckMemberRoleFeatures() {
        if (this.projectId && this.memberId && this.groupId)
            this._commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {
                this._isSuperEdit = res.filter(x => x.feature_Id == 6).length > 0 ? true : false;
            });

    }

    getDynamicForm() {
        let GetprojectElements = this._projInfoService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: false }).subscribe(
            (res: IProjectElementsOutput[]) => {
                this.projectElements = res;
                this.projectElements.forEach(element => {
                    if (element.elementDescription != 'Project Code') {
                        this.searchTypeList.push({ value: element.elementId, description: element.elementDescription });
                    }
                });
                this.regConfig = res.map(x => {
                    let field: FieldConfig;
                    let childDEId = null;
                    let childDEDescription = "";
                    let data = res.filter(item => item.dependentElementId == x.elementId);
                    if (data.length > 0) {
                        childDEId = data[0].elementId;
                        childDEDescription = data[0].elementDescription;
                    }
                    field = {
                        de_id: x.elementId,
                        module_id: Module.ScheduleDocument,
                        dependent_de_id: x.dependentElementId,
                        dependent_de_Description: x.dependentElementDescription,
                        child_de_id: childDEId,
                        child_de_Description: childDEDescription,
                        name: x.elementDescription,
                        deDescription: x.elementDescription,
                        type: 'select'
                    }
                    return field;
                });
                this.dynamicForm.fields = this.regConfig;
                this.dynamicForm.createControl();
            });
        this.UnsubscribeArray.push(GetprojectElements);
    }
    loadAllStages() {
        this._projInfoService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Workflow, deDescription: 'Workflow Status' }).toPromise().then((res: IProjectElementDetailsOutput[]) => {
            this.stageList = res.map(val => {
                val.displayText = val.dedShortDescription + " - " + val.dedDescription;
                return val;
            }).sort((a, b) => a.sortBy - b.sortBy);

            this.stageList.forEach((x, index) => {
                this.stageColors.set(x.dedShortDescription, this.colorCodes[index]);
            });
        });
    }

    getStageColor(currentStage: string) {
        if (!!currentStage && this.stageColors.has(currentStage)) {
            return this.stageColors.get(currentStage);
        }
        return null;
    }
    enableMemberRoleFeatures() {
        let _getProjectMemberFeatures = this._commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {

            this.isShowStartWF = res.some(data => data.feature_Desc == 'Start Workflow');
            this.isShowWFHistory = res.some(data => data.feature_Desc == 'Workflow History');
            this.isShowEdit = res.some(data => data.feature_Desc == 'Edit');
            this.isShowSuperEdit = res.some(data => data.feature_Desc == 'Super Edit');
            this.isShowSupersede = res.some(data => data.feature_Desc == 'Supersede');
            this.isShowApprove = res.some(data => data.feature_Desc == 'Approve');
            this.canUpload = res.some(data => data.feature_Desc == 'Upload');
            this.canView = res.some(data => data.feature_Desc == 'View');
            this.canDelete = res.some(data => data.feature_Desc == 'Delete');
        });
        this.UnsubscribeArray.push(_getProjectMemberFeatures);
    }

    ngAfterViewInit() {
        let selectedTab = this.tabGroup._tabs._results[this.tabGroup.selectedIndex];

        if (selectedTab.textLabel.toUpperCase() == "APPROVED" || selectedTab.textLabel.toUpperCase() == "ALL")
            this.isShowWFIcon = true;
        else
            this.isShowWFIcon = false;

        if (selectedTab.textLabel.toUpperCase() == "APPROVED" || selectedTab.textLabel.toUpperCase() == "COMPLETED")
            this.isShowSupersedeIcon = true;
        else
            this.isShowSupersedeIcon = false;
    }

    loadDocSetTree() {
        let _getDocSetListByGroup = this._scheDefService.getDocSetListByGroup({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: any) => {
            res.forEach((data: any) => {
                if (!!data) {
                    data["type"] = "Header";
                } if (!!data.items) {
                    data.items.forEach((element: { [x: string]: string; }) => {
                        element["type"] = "child";
                    });
                }
            });
            this.docSetHierarchy = res;
        });
        this.UnsubscribeArray.push(_getDocSetListByGroup);
    }

    loadscheduleDocumnets(input?: IPorjectInputModel) {
        let inputModel: IPorjectInputModel;
        if (input)
            inputModel = input;
        else {
            inputModel = { project_Id: this.projectId, group_Id: this.groupId };
            if (this.lastViewingRecords > 0)
                inputModel.latestRecords_Count = this.lastViewingRecords;
            if (this._commonService.hasRequestedObject()) {
                var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this._commonService.getSessionStorageItem('requestedObject')));
                inputModel.docId = requestedObject['inputDocId'];
                inputModel.revisionNo = requestedObject['inputRevNo'];
            }
            if (this._commonService.hasSearchedObject()) {
                var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this._commonService.getSessionStorageItem('searchedObject')));
                inputModel.docNo = searchedObject['searchDocNo'];
                inputModel.revisionNo = searchedObject['searchRevNo'];
            }
        }
        let _GetScheduleDocList = this._scheduleDocService.GetScheduleDocList(inputModel).subscribe((res: IScheduleDocInfo[]) => {
            res.forEach(x => x.isSelected = false)
            this.gridAllData = res;
            this.gridAllRevisionData = res;
            //Refresh the grid based on Latest/All revisions
            this.refreshGrid();
            // this.loadGridItems();
            this.setRedirectObjects();
        });
        this.UnsubscribeArray.push(_GetScheduleDocList);
    }

    setRedirectObjects() {
        if (this.gridAllData.length > 0 && this._commonService.hasSearchedObject()) {/*Search Redirection*/
            var searchedObject = JSON.parse(this.encryptDecryptService.decrypt(this._commonService.getSessionStorageItem('searchedObject')));
            let inputdocNo = searchedObject['searchDocNo'];
            let inputRevNo = searchedObject['searchRevNo'];
            if (inputdocNo && inputRevNo) {
                this._commonService.checkAndDeleteSearchedObject();
                let _data = this.gridAllData.filter(x => x.doc_No == inputdocNo && x.revision_No == inputRevNo);
                if (_data.length > 0) {
                    this.viewDocumentClick(_data[0]);
                }
                else {
                    this._notificationService.showToast("You are not authorized to view the document", "Warning");
                }
            }
        }
    }

    createSearchFieldsForm() {
        this.schSeachFieldsConfig = this.getSchSearchConfig();
        this.schSearchDynamicForm.fields = this.schSeachFieldsConfig;
        this.schSearchDynamicForm.createControl();
    }

    createdocument() {
        let dialogRef = this.dialog.open(BulkScheduleUploadComponent, {
            panelClass: 'mat-dialog-primary',
            data: { num: 1, isStdDCI: false }
        });
        let _dialogRef = dialogRef.afterClosed().subscribe((res: any) => {
            //If save and add new means, show the dialog again
            if (res)
                this.createdocument();
            else
                this.loadscheduleDocumnets();
        });
        this.UnsubscribeArray.push(_dialogRef);
    }

    public advanceSearch() {
        this.isSearch = !this.isSearch;
        if (this.isSearch)
            this.createSearchFieldsForm();
    }

    onHover(event: Event): void {
        if ((event.target as HTMLElement).closest('div.k-grid-content')) {
            const newscrollLeft = (event.target as HTMLElement).closest('div.k-grid-content')?.scrollLeft;
            if (this.lastscrollLeft !== newscrollLeft) {
                for (let i = 0; i < this.divIconHover.length; i++) {
                    this.divIconHover['_results'][i]['nativeElement']['style'].right = (0 - newscrollLeft) + 'px';
                }
                this.lastscrollLeft = newscrollLeft;
            }
        }
    }

    /**
 * Multiple select of listed documents for approval or reject
 * @param event
 *
 */
    onSelectionChange(event: any): void {
        if (event['selectedRows'].length > 0) {
            event['selectedRows'].forEach((element: any) => {
                element.dataItem.isSelected = true;
            });
        }
        if (event['deselectedRows'].length > 0) {
            event['deselectedRows'].forEach((element: any) => {
                element.dataItem.isSelected = false;
            });
        }
        let count = this.gridData.filter(x => x.isSelected).length;
        if (count > 1)
            this.enableRowWiseWFIcon = false;
        if (count <= 1)
            this.enableRowWiseWFIcon = true;
    }

    toggleFilter() {
        this.enableFilter = !this.enableFilter;
    }

    /**
    * Get Schedule document serach fields
    * @returns FieldConfig[]
    */
    getSchSearchConfig(): FieldConfig[] {
        return [
            {
                type: 'eipdatepicker',
                name: 'fromDate',
                label: 'From'
            },
            {
                type: 'eipdatepicker',
                name: 'toDate',
                label: 'To'
            }];
    }


    public handleSelection(value?: any) {
        if (value != false) {
            this.treeFilter = value;
        }
        let DisciplineId!: number;
        let structureObj!: number;
        this.docSetHierarchy.forEach(data => {
            if (data.dedId == this.treeFilter.dataItem.dedId) {
                DisciplineId = this.treeFilter.dataItem.dedId;
            }
            else if (this.treeFilter.dataItem.documentSet) {
                DisciplineId = this.treeFilter.dataItem.documentSet.disc_DED_Id;
                structureObj = this.treeFilter.dataItem.documentSet.structure_DED_Id;
            }
            else {
                data.items.forEach((element: any) => {
                    if (element.dedId == this.treeFilter.dataItem.dedId) {
                        let indexarray = value.index.split('_');
                        DisciplineId = this.docSetHierarchy[indexarray[0]].dedId;
                        structureObj = element;
                    }
                });
            }
        })
        let selectedItem: INavigationTree = this.treeFilter.dataItem;
        // let test = this.getGridAllData();
        if (!!selectedItem && selectedItem.documentSet == null) {
            let GridData = this.getGridAllData();
            if (DisciplineId) {
                this.gridData = GridData.filter(doc => {
                    return !!doc.dciScheduleElementDetails?.some(data => data.deD_Id == DisciplineId)
                });
                if (structureObj) {
                    this.gridData = this.gridData.filter(doc => {
                        return !!doc.dciScheduleElementDetails?.some(data => data.deD_Id == this.treeFilter.dataItem.dedId)
                    });
                }
            }
            this.selectedDocSet = value;
            //this.searchDci(true);            
            return;
        }
        if (selectedItem && selectedItem.documentSet) {
            this.gridData = this.getGridAllData().filter(x => x.doc_Set_Name == selectedItem.documentSet.document_Set_Name);
            //Retain the last selected docset value for search filter
            this.selectedDocSet = value;
            this.searchDci(true);
        }
    }

    public closeAdvSearch(event: any) {
        this.isSearch = false;
    }

    onHoverTrigger(event: any) {
        this.hoverClass = 'open';
        this.IsShowSection = !this.IsShowSection;
        if (!this.IsShowSection && this.selectedDocSet) {
            this.selectedDocSet = null;
            this.searchDci(false);
        }
    }

    createMessageClick() {
        let selectedDocuments = this.gridData.filter(data => data.isSelected == true)[0];
        let selectedDocumentsList = [];
        if (selectedDocuments != undefined && selectedDocuments != null) {
            selectedDocumentsList = this.gridData.filter(val => val.isSelected == true).map(x => {
                return {
                    docId: x.doc_Id,
                    documentNo: x.doc_No,
                    title: x.doc_Title,
                    revision: x.revision_No,
                    authorisedByName: x.authorized_By,
                    createdByName: x.created_By
                }
            });
        }
        else {
            selectedDocumentsList = this.gridData.filter(val => val.isSelected).map(x => {
                return {
                    docId: x.doc_Id,
                    documentNo: x.doc_No,
                    title: x.doc_Title,
                    revision: x.revision_No,
                    authorisedByName: x.authorized_By,
                    createdByName: x.created_By
                }
            });
        }
        if (!!selectedDocuments) {
            const dialogRef = this.dialog.open(CreateMessageComponent, {
                panelClass: 'mat-dialog-primary',
                data: { inputType: 'createDocumentMail', selectedList: selectedDocumentsList }
            });
        }
        else {
            this._notificationService.showToast("Please Select Atleast One Document", "Warning");
        }
    }

    searchDci(isFromNavTree: boolean) {
        this.directive.skip = 0;

        let dynamicForm: FormGroup;
        if (this.schSearchDynamicForm)
            dynamicForm = this.schSearchDynamicForm.value;

        let fromDateValue: any;
        let toDateValue: any;
        if (dynamicForm) {
            fromDateValue = dynamicForm.get('fromDate').value;
            toDateValue = dynamicForm.get('toDate').value;
        }
        let fromDate: Date;
        let toDate: Date;
        //Reset the grid collection before filtering
        if (!isFromNavTree) {
            if (this.selectedDocSet)
                this.handleSelection(this.selectedDocSet);
            else
                this.gridData = this.getGridAllData();
        }
        if (fromDateValue && toDateValue) {
            fromDate = moment(fromDateValue.value).toDate();
            toDate = moment(toDateValue.value).toDate();
            this.gridData = this.gridData.filter(x => {
                let createdOn: Date = new Date(this.datepipe.transform(x.created_On, "dd-MMM-yyyy"));
                return createdOn && new Date(createdOn) >= fromDate && new Date(createdOn) <= toDate;
            });
        }
        if (fromDateValue) {
            fromDate = moment(fromDateValue.value).toDate();
            this.gridData = this.gridData.filter(x => {
                let createdOn: Date = new Date(this.datepipe.transform(x.created_On, "dd-MMM-yyyy"));
                return createdOn && new Date(createdOn) >= fromDate
            });
        }
        if (toDateValue) {
            toDate = moment(toDateValue.value).toDate();
            this.gridData = this.gridData.filter(x => {
                let createdOn: Date = new Date(this.datepipe.transform(x.created_On, "dd-MMM-yyyy"));
                return createdOn && new Date(createdOn) <= toDate
            });
        }
    }

    /**
     * Reset the search fields
     */
    resetSearch() {
        this.createSearchFieldsForm();
        this.searchDci(false);
    }

    receviewData(data: any) {
        let inputModel: IPorjectInputModel = {
            project_Id: this.projectId
            , group_Id: this.groupId
            , disc_Id: data.disc_Id
            , struct_Id: data.struct_Id
            , drg_Type: data.drg_Type
            , stages: data.stages
            , transmittal_no: data.transmittal_no
            , schedule_Type: (data.schedule_Type && data.schedule_Type.length > 0 ? data.schedule_Type.toString() : null)
            , docNo: data.doc_no
            , docset_id: data.docset_id
            , schedule_from: this.datepipe.transform(data.from_Date, "yyyy-MM-dd")
            , schedule_to: this.datepipe.transform(data.to_Date, "yyyy-MM-dd")
        };
        this.loadscheduleDocumnets(inputModel)
    }

    AdvanceSearch() {
        this.ADSearchComponent = !this.ADSearchComponent
        if (!this.ADSearchComponent)
            this.refreshGrid()
    }
    /**
     * Status tab click for Approve,Reject and All Documents
     * @param event 
     */

    tabClick(event: any) {
        //this.ADSearchComponent = false;
        this.directive.skip = 0;
        //Reset the selection while tab changes
        this.dciGrid.defaultSelection.selectedKeys = [];
        //Reset the isselected flag as false
        this.gridAllData.forEach(x => x.isSelected = false);

        this.enableFilter = false;
        this.directive.filter = undefined;

        //Reset the skip count
        this.skip = 0;
        //Whenever tab change event raised,trigger the searc DCI method
        this.searchDci(false);

        this.IslatestShow = false;
        this.isLatest = true;
        this.isCanApprove = true
        this.isCanReject = true;
        this.isShowWFIcon = false;
        this.isShowSupersedeIcon = false;
        this.completeEditHide = true;

        if (event.tab.textLabel.toUpperCase() == "FOR ACTION") {
            this.IslatestShow = false;
            this.isLatest = true;
            this.isCanApprove = true
            this.isCanReject = true;
            this.isShowWFIcon = false;
            this.isShowSupersedeIcon = false;
            this.completeEditHide = true;
        }
        else if (event.tab.textLabel.toUpperCase() == "APPROVED") {
            this.IslatestShow = false;
            this.isLatest = true;
            this.isCanApprove = false
            this.isCanReject = false;
            this.isShowWFIcon = true;
            this.isShowSupersedeIcon = true
            this.completeEditHide = true;
        }
        else if (event.tab.textLabel.toUpperCase() == "REJECTED") {
            this.IslatestShow = false;
            this.isLatest = true;
            this.isCanApprove = true;
            this.isCanReject = false;
            this.isShowWFIcon = false;
            this.isShowSupersedeIcon = false;
            this.completeEditHide = true;
        }
        else if (event.tab.textLabel.toUpperCase() == "IN PROGRESS") {
            this.IslatestShow = false;
            this.isLatest = true;
            this.isCanApprove = false;
            this.isCanReject = false;
            this.isShowWFIcon = false;
            this.isShowSupersedeIcon = false;
            this.completeEditHide = true;
        }
        else if (event.tab.textLabel.toUpperCase() == "ON HOLD") {
            this.IslatestShow = false;
            this.isLatest = true;
            this.isCanApprove = false;
            this.isCanReject = false;
            this.isShowWFIcon = false;
            this.isShowSupersedeIcon = false;
            this.completeEditHide = true;
        }
        else if (event.tab.textLabel.toUpperCase() == "COMPLETED") {
            this.IslatestShow = true;
            this.isLatest = true;
            this.isCanApprove = false;
            this.isCanReject = false;
            this.isShowWFIcon = false;
            this.isShowSupersedeIcon = true;
            this.completeEditHide = false;
        }
        else if (event.tab.textLabel.toUpperCase() == "ALL") {
            this.IslatestShow = true;
            this.isLatest = true;
            this.isCanApprove = false;
            this.isCanReject = false;
            this.isShowWFIcon = true;
            this.isShowSupersedeIcon = false;
            this.completeEditHide = true;
        }
    }

    refreshGrid() {
        if (this.isLatest) {
            this.gridAllData = this.gridAllRevisionData.filter(doc => doc.is_Latest == true);
            this.gridData = this.getGridAllData();
            if (!!this.treeFilter && this.IsShowSection == true) {
                this.handleSelection(false);
            }
        } else {
            this.gridAllData = this.gridAllRevisionData;
            this.gridData = this.getGridAllData();
        }
        if (!!this.treeFilter && this.IsShowSection == true) {
            this.handleSelection(false);
        }
    }

    getGridAllData(): IScheduleDocInfo[] {
        let gridDataArr: IScheduleDocInfo[] = [];
        this.approvedCount = this.gridAllData.filter(x => x.approved_Tag == true && x.approved_On != null && !x.is_WF_Started && !x.isCompleted).length;
        this.rejectedCount = this.gridAllData.filter(x => x.approved_Tag == false && x.approved_On != null).length;
        this.forActionCount = this.gridAllData.filter(x => x.approved_Tag == false && x.approved_On == null).length;
        this.inprogressCount = this.gridAllData.filter(x => x.approved_Tag == true && x.approved_On != null && x.is_WF_Started && !x.isCompleted && x.hold == false).length;
        this.holdedCount = this.gridAllData.filter(x => x.hold == true).length;
        this.completedCount = this.gridAllData.filter(x => x.isCompleted == true && x.hold == false).length;
        this.totalCount = this.gridAllData.length;
        switch (this.selectedRootIndex) {
            case 0:
                gridDataArr = this.gridAllData.filter(x => x.approved_Tag == false && x.approved_On == null && x.is_Latest == true);
                this.forActionCount = gridDataArr.length;
                this.isCanApprove = true;
                this.isCanReject = true;
                break;
            case 1:
                gridDataArr = this.gridAllData.filter(x => x.approved_Tag == true && x.approved_On != null && !x.is_WF_Started && !x.isCompleted && x.is_Latest == true);
                this.approvedCount = gridDataArr.length;
                this.isCanApprove = false;
                this.isCanReject = false;
                break;
            case 2:
                gridDataArr = this.gridAllData.filter(x => x.approved_Tag == false && x.approved_On != null && x.is_Latest == true);
                this.rejectedCount = gridDataArr.length;
                this.isCanApprove = true;
                this.isCanReject = false;
                break;
            case 3:
                gridDataArr = this.gridAllData.filter(x => x.approved_Tag == true && x.approved_On != null && x.is_WF_Started && !x.isCompleted && x.is_Latest == true && x.hold == false);
                this.inprogressCount = gridDataArr.length;
                this.isCanApprove = false;
                this.isCanReject = false;
                break;
            case 4:
                gridDataArr = this.gridAllData.filter(x => x.hold == true);
                this.holdedCount = gridDataArr.length;
                this.isCanApprove = false;
                this.isCanReject = false;
                break;
            case 5:
                gridDataArr = this.gridAllData.filter(x => x.isCompleted == true && x.hold == false);
                this.completedCount = gridDataArr.length;
                this.isCanApprove = false;
                this.isCanReject = false;
                break;
            default:
                gridDataArr = this.gridAllData;
                this.totalCount = gridDataArr.length;
                this.isCanApprove = false;
                this.isCanReject = false;
                break;
        }
        return gridDataArr;
    }

    GetSupercedeDCIDetails() {
        this.SupercedeDCIDetails = [];
        this.gridData.filter(x => x.isSelected).forEach(y => {
            this.SupercedeDCIDetails.push(y);
        })
        if (this.SupercedeDCIDetails && this.SupercedeDCIDetails.length > 0) {

            if (this.SupercedeDCIDetails.length > 20) {
                this._notificationService.showPopup("No of documents should not exceed 20 !!!", "Warning");
                return;
            }

            this._notificationService.showPopup('Are you sure to Supersede the Selected Documents ?', 'Confirm').then(data => {
                if (data == 'yes') {
                    let dialogRef = this.dialog.open(BulkDCISupersedeComponent, {
                        panelClass: 'mat-dialog-primary',
                        data: this.SupercedeDCIDetails,
                        autoFocus: false
                    });
                    let _DciSupersedeComponent = dialogRef.afterClosed().subscribe(res => {
                        this.loadscheduleDocumnets();
                    });
                    this.UnsubscribeArray.push(_DciSupersedeComponent);
                }
            });
        }
        else {
            this._notificationService.showPopup("Kindly Select Documents to Supersede!!!", "Warning");
        }
    }

    /**
     * Approve or Reject Multi or Single Document
     * @param isApproved 
     */
    approveDCIDocs(isApproved: boolean) {
        this.scheduleApprovalDocDetails = [];
        this.gridData.filter(x => x.isSelected).forEach(y => {
            this.scheduleApprovalDocDetails.push({ doc_Id: y.doc_Id, revision_No: y.revision_No });
        })
        this.approveDciDocuments(isApproved);
    }

    /**
     * Approve or Reject Document inline hover
     * @param isApproved 
     * @param dataItem 
     */
    approveDCI(isApproved: boolean, dataItem: IScheduleDocInfo) {
        this.scheduleApprovalDocDetails = [];
        this.scheduleApprovalDocDetails.push({ doc_Id: dataItem.doc_Id, revision_No: dataItem.revision_No });
        this.approveDciDocuments(isApproved);
    }

    /**
     * Approve or Reject DCI Documents
     * @param isApproved 
     */
    approveDciDocuments(isApproved: boolean) {
        if (this.scheduleApprovalDocDetails.length > 0) {
            let inputModel: IScheduleDocApprovalDetails = {
                DocSchApproveDetails: this.scheduleApprovalDocDetails,
                approved_Tag: isApproved,
                userId: this.memberId
            };
            let _InsertUpdateScheduleApprovalDetails = this._scheduleDocService.InsertUpdateScheduleApprovalDetails(inputModel).subscribe((res: StandardOutputModel) => {
                if (res.successCode == 200) {
                    this._notificationService.showToast(res.successMessage, "Success");
                }
                else if (res.successCode == 205) {
                    this._notificationService.showToast(res.successMessage, "Warning");
                }
                this.loadscheduleDocumnets();
            });
            this.UnsubscribeArray.push(_InsertUpdateScheduleApprovalDetails);
        }
        else {
            this._notificationService.showToast("No document is selected", "Warning");
        }
    }

    viewTabClick(event: MatTabChangeEvent) {
        this.viewSchDoc = null;
        if (this.selectedTabIndex != 0) {
            this.viewSchDoc = this.viewDciTabList[this.selectedTabIndex - 1];
        }
    }

    /**
     * View DCI Document
     * @param data 
     */
    viewDocumentClick(data: IScheduleDocInfo) {
        let index = this.viewDciTabList.indexOf(data);
        if (index == -1) {
            this.viewDciTabList.push(data);
            this.selectedTabIndex = this.viewDciTabList.length;
        }
        this.ADSearchComponent = false;
    }

    onClick_Compare() {
        let dialogRef = this.dialog.open(FileCompareComponent, {
            panelClass: 'mat-dialog-primary'
        });
    }

    closeViewTab(tab: IScheduleDocInfo) {
        this.viewDciTabList.forEach((value, index) => {
            if (value.doc_Id == tab.doc_Id)
                this.viewDciTabList.splice(index, 1);
        });
        if (this.viewDciTabList.length == 0) {
            this.selectedTabIndex = 0;
        }
        this.loadscheduleDocumnets();
    }

    /**
     * View Multi or Single Document
     */
    viewDCIDocumentsClick() {
        this.gridData.filter(x => x.isSelected).forEach(element => {
            let index = this.viewDciTabList.indexOf(element);
            if (index == -1) {
                this.viewDciTabList.push(element);
                this.selectedTabIndex = 1;
            }
        });
        if (this.viewDciTabList.length == 0) {
            this._notificationService.showToast("No document is selected", "Warning");
        }
        this.ADSearchComponent = false;
    }

    public downloadDCIExcelTemplate() {
        this.loaderService.isLoading.next(true);
        let projectModel: ProjectViewModel = this._commonService.getCurrentProjectDetails();
        let inputData: IPorjectInputModel = { project_Id: this.projectId, group_Id: this.groupId, startDate: projectModel.startDate, endDate: projectModel.endDate }
        let fileName = "DCI_Excel_Template-" + this.projectCode + ".xlsx";
        let _GetDCIExcelTemplate = this._scheduleDocService.GetDCIExcelTemplate(inputData).subscribe((data: any) => {
            this.loaderService.isLoading.next(false);
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(data);
            downloadLink.download = fileName;
            downloadLink.click();
            document.body.removeChild(downloadLink);
        },
            (err: any) => {
                this.loaderService.isLoading.next(false);
                this._notificationService.showToast("Error in downloading Template", "Warning");
            });
        this.UnsubscribeArray.push(_GetDCIExcelTemplate);
    }

    private processFile = async (inputFile: any) => {
        const temporaryFileReader = new FileReader();
        return new Promise((resolve, reject) => {
            temporaryFileReader.readAsArrayBuffer(inputFile);
            temporaryFileReader.onload = (event) => {
                resolve(event && event.target && event.target['readyState'] == FileReader.DONE ? (new Uint8Array(<ArrayBuffer>event.target['result'])) : null);
            };
        });
    };

    private async UploadISOExcel(event: any) {
        this.loaderService.isLoading.next(true);
        if (event.target.files[0].type != this.acceptFileTypes) {
            this.loaderService.isLoading.next(false);
            this._notificationService.showPopup("File type is incorrect(*.xlsx file type expected)", "Warning");
            this.excelISOUpload.nativeElement.value = null;
            return;
        }
        let _file = event.target.files[0];
        const formData: FormData = new FormData();
        let _filedetails: any = [].slice.call(await this.processFile(_file))
        formData.append('ISOExcel', event.target.files[0], event.target.files[0].name);
        formData.append('ProjectId', this.projectId.toString());
        formData.append('GroupId', this.groupId.toString());
        formData.append('MemberId', this.memberId.toString());
        if (_filedetails)
            formData.append('fileAsByteArray', _filedetails);

        let _UploadISOExcel = this._scheduleDocService.UploadISOExcel(formData).subscribe((res: IScheduleISODocUploadDetailsModel[]) => {
            this.loaderService.isLoading.next(false);
            if (res.length > 0) {
                //this._notificationService.showToast("Excel Uploaded Successfully..", "Success");
                let dialogRef = this.dialog.open(ISODCIUploadComponent, {
                    panelClass: 'mat-dialog-primary',
                    data: res,
                });
                dialogRef.afterClosed().subscribe((res: any) => {
                    this.loadscheduleDocumnets();
                });
                this.UnsubscribeArray.push(_UploadISOExcel);
            }
            else {
                this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
            }
            this.excelISOUpload.nativeElement.value = null;
        }, (err: any) => {
            this.loaderService.isLoading.next(false);
            this.excelISOUpload.nativeElement.value = null;
            this._notificationService.showToast("Error in upload Template", "Warning");
        })
        this.UnsubscribeArray.push(_UploadISOExcel);
    }

    UploadISOClick() {
        if (this.isDocSetRequired)
            this._notificationService.showPopup("ISO DCI Upload is not applicable for Document Set Enabled Projects!!!", "Warning");
        else
            this.excelISOUpload.nativeElement.click();
    }

    uploadDCIClick() {
        this.excelDCIUpload.nativeElement.click();
    }

    uploadDCITemplate(event: any) {
        this.loaderService.isLoading.next(true);
        if (event.target.files[0].type != this.acceptFileTypes) {
            this.loaderService.isLoading.next(false);
            this._notificationService.showPopup("File type is incorrect(*.xlsx file type expected)", "Warning");
            this.excelDCIUpload.nativeElement.value = '';
            return;
        }
        const formData: FormData = new FormData();
        formData.append('DCIExcelTemplate', event.target.files[0], event.target.files[0].name);
        formData.append('ProjectId', this.projectId.toString());
        formData.append('GroupId', this.groupId.toString());
        formData.append('MemberId', this.memberId.toString());
        let _UploadDCIExcelTemplate = this._scheduleDocService.UploadDCIExcelTemplate(formData).subscribe((res: IScheduleDocUploadStatusModel[]) => {
            this.loaderService.isLoading.next(false);
            if (res.length > 0) {
                //this._notificationService.showToast("Excel Uploaded Successfully..", "Success");
                let dialogRef = this.dialog.open(ScheduleExcelUploadComponent, {
                    panelClass: 'mat-dialog-primary',
                    data: res,
                });
                let _ScheduleExcelUploadComponent = dialogRef.afterClosed().subscribe((res: any) => {
                    this.loadscheduleDocumnets();
                });
                this.UnsubscribeArray.push(_ScheduleExcelUploadComponent);
            }
            else {
                this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
            }
            this.excelDCIUpload.nativeElement.value = '';
        }, (err: any) => {
            this.loaderService.isLoading.next(false);
            this.excelDCIUpload.nativeElement.value = '';
            this._notificationService.showToast("Error in upload Template", "Warning");
        })
        this.UnsubscribeArray.push(_UploadDCIExcelTemplate);
    }

    viewDci(dataItem: IScheduleDocInfo) {
        let dialogRef = this.dialog.open(ScheduleEditComponent, {
            panelClass: 'mat-dialog-primary',
            data: { dataItem: dataItem, isSuperEdit: this._isSuperEdit },
            autoFocus: false,
            disableClose: true
        });
        let __dialogRef = dialogRef.afterClosed().subscribe((res: any) => {
            this.loadscheduleDocumnets();
        })
        this.ADSearchComponent = false;
        this.UnsubscribeArray.push(__dialogRef);
    }

    deleteDci(dataItem: IScheduleDocInfo) {
        this._notificationService.showPopup('Are you sure you want to delete?', 'Confirm').then(msg => {
            if (msg == 'yes') {
                let reaData = {
                    "docId": dataItem.doc_Id,
                    "revisionNo": dataItem.revision_No,
                    "userId": this._commonService.getLoggedInUserId()
                };
                let _DeleteDoc = this._docService.DeleteDoc(reaData).subscribe((res: any) => {
                    if (res.successCode == 200) {
                        this.refreshGrid();
                        this._notificationService.showToast(res.successMessage, "Success");
                    }
                    else if (res.successCode == 500) {
                        this._notificationService.showToast(res.successMessage, "Error");
                    }
                });
                this.UnsubscribeArray.push(_DeleteDoc);
            }
        });
    }


    public onClick_WorkflowSupersede(dataItem: IScheduleDocInfo) {
        this._notificationService.showPopup('Are you sure to supersede the selected Document?', 'Confirm').then(data => {
            if (data == 'yes') {
                let dialogRef = this.dialog.open(DciSupersedeComponent, {
                    panelClass: 'mat-dialog-primary',
                    data: dataItem,
                    autoFocus: false
                });
                let _DciSupersedeComponent = dialogRef.afterClosed().subscribe((res: any) => {
                    this.loadscheduleDocumnets();
                });
                this.UnsubscribeArray.push(_DciSupersedeComponent);
            }
        });
    }
    sameDiscipline!: boolean;
    ccnsameDiscipline!: boolean;
    public onClick_StartWorkflow(dataItem: IScheduleDocInfo, currentDoc: any) {
        this.sameDiscipline = false;
        this.ccnsameDiscipline = false;
        let dciToStartWorkflow: any = [];
        let hasError = false;
        if (dataItem) {
            if (dataItem.is_WF_Started && !dataItem.can_Restart_WF) {
                hasError = true;
                this._notificationService.showToast("Workflow has been initiated for the selected document", "Warning");
                return;
            }
            if (!dataItem.is_WF_Started && dataItem.can_Restart_WF) {
                dciToStartWorkflow.push({ isSelected: false, documentId: dataItem.doc_Id, documentNumber: dataItem.doc_No, documentTitle: dataItem.doc_Title, revisionNumber: dataItem.revision_No, workflowId: dataItem.workflow_Id, DciScheduleElementDetails: dataItem.dciScheduleElementDetails });
            }
            else if (dciToStartWorkflow.filter((x: { documentId: number; }) => x.documentId == dataItem.doc_Id).length == 0)
                dciToStartWorkflow.push({ isSelected: false, documentId: dataItem.doc_Id, documentNumber: dataItem.doc_No, documentTitle: dataItem.doc_Title, revisionNumber: dataItem.revision_No, workflowId: dataItem.workflow_Id, DciScheduleElementDetails: dataItem.dciScheduleElementDetails });
        }
        if (!dataItem) {
            let selected_data = this.gridData.filter(x => x.isSelected);
            if (selected_data.length > 0) {
                let checkApprove = selected_data.some(doc => doc.approved_Tag == false);
                if (checkApprove) {
                    hasError = true;
                    this._notificationService.showToast("Approval is pending for some of the selected document(s), please exclude", "Warning");
                    return;
                }
            }
            this.gridData.filter(x => x.isSelected).forEach(y => {
                if (y.is_WF_Started && !y.can_Restart_WF) {
                    hasError = true;
                    dciToStartWorkflow = [];
                    this._notificationService.showToast("Workflow has been initiated for some of the selected document(s), please exclude", "Warning");
                    return;
                }
                if (!y.is_WF_Started && y.can_Restart_WF) {
                    dciToStartWorkflow.push({ isSelected: false, documentId: y.doc_Id, documentNumber: y.doc_No, documentTitle: y.doc_Title, revisionNumber: y.revision_No, workflowId: y.workflow_Id, DciScheduleElementDetails: y.dciScheduleElementDetails });
                    return;
                }
                if (dciToStartWorkflow.filter((x: { documentId: number; }) => x.documentId == y.doc_Id).length == 0)
                    dciToStartWorkflow.push({ isSelected: false, documentId: y.doc_Id, documentNumber: y.doc_No, documentTitle: y.doc_Title, revisionNumber: y.revision_No, workflowId: y.workflow_Id, DciScheduleElementDetails: y.dciScheduleElementDetails });
            });
            const distinctThings = dciToStartWorkflow.filter(
                (thing: { workflowId: any; }, i: any, arr: any[]) => arr.findIndex(t => t.workflowId === thing.workflowId) === i
            );
            let Doc_discipline: any;
            if (dciToStartWorkflow.length > 0) {
                Doc_discipline = dciToStartWorkflow[0].DciScheduleElementDetails.filter((val: any) => val.dE_Description == "Discipline")[0];
            }
            if (distinctThings.length > 1) {
                hasError = true;
                this._notificationService.showToast("Selected document number contains different workflows", "Warning");
                return;
            }

            if (dciToStartWorkflow.length > 0) {
                dciToStartWorkflow.forEach((val: any) => {
                    this.sameDiscipline = val.DciScheduleElementDetails.some((doc: any) => {

                        //return doc.dE_Description == "Discipline" && doc.deD_Id != doc_discipline.deD_Id
                        if (doc.dE_Description == "Discipline") {
                            if (doc.deD_Id != Doc_discipline.deD_Id) {
                                return true;
                            }
                        }
                    })
                })
            }
            if (this.sameDiscipline) {
                hasError = true;
                this._notificationService.showToast("Selected document number contains different discipline", "Warning");
                return;
            }

            if (this.ccnsameDiscipline) {
                hasError = true;
                this._notificationService.showToast("Selected document number contains different discipline", "Warning");
                return;
            }
        }

        if (dciToStartWorkflow.length == 0) {
            this._notificationService.showPopup("Kindly Select Documents to Start Workflow!!!", "Warning");
            return;
        }

        if (!hasError && dciToStartWorkflow.length > 0) {
            let dialogRef = this.dialog.open(ScheduleStartWorkflowComponent, {
                panelClass: 'mat-dialog-primary',
                data: { dciToStartWorkflow, currentDoc },
                autoFocus: false
            });
            let _ScheduleStartWorkflowComponent = dialogRef.afterClosed().subscribe(() => {
                dciToStartWorkflow = [];
                hasError = false;
                this.loadscheduleDocumnets();
                this.dciGrid.defaultSelection.selectedKeys = [];
                this.gridAllData.forEach(x => x.isSelected = false);
                this.isShowWFIcon = true;
                this.enableRowWiseWFIcon = true;
            });
            this.UnsubscribeArray.push(_ScheduleStartWorkflowComponent);
        }
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadGridItems();
    }

    private loadGridItems(): void {
        this.gridView = {
            data: this.gridData.slice(this.skip, this.skip + this.pageSize),
            total: this.gridData.length,
        };
    }

    public onClick_WorkflowHistory(dataItem: IScheduleDocInfo) {
        let dialogRef = this.dialog.open(ScheduleWorkflowhistoryComponent, {
            panelClass: 'mat-dialog-content',
            data: dataItem
        });

        let _ScheduleWorkflowhistoryComponent = dialogRef.afterClosed().subscribe((data: any) => {
        });
        this.UnsubscribeArray.push(_ScheduleWorkflowhistoryComponent);
    }

    viewMessageList(category: number, data: any) {
        let inputModel: IDocumentMailInputModel = {
            DocId: data.doc_Id,
            DocumentNo: data.doc_No,
            Category: category,
            ProjectId: this.projectId,
            GroupId: this.groupId,
            MemberId: this.memberId,
            TransType: "",
            revisionNo: data.revision_No
        };
        this.dialog.open(ScheduleDocumentMailListComponent, {
            panelClass: ['mat-dialog-secondary', 'w80'],
            data: inputModel
        });
    }

    viewAttachmentClick(data: any) {
        this.dialog.open(FileListComponent, {
            panelClass: ['mat-dialog-secondary', 'w80'],
            data: { projectId: this.projectId, docId: data.doc_Id, revisionNo: data.revision_No, libraryName: [FileUploadLibrary.WorkflowDocument, FileUploadLibrary.SignedDocuments], createdBy: this.memberId, isDeleteEnable: false, documentNo: data.doc_No },
        });
    }

    public openRevHistory(event: any, docId: number) {
        this.showRevHistory = !this.showRevHistory;
        if (this.showRevHistory) {
            this.revHistory = {
                docId: docId,
                groupId: this.groupId,
                memberId: this.memberId,
                transType: "Project"
            };
        }
        else {
            this.revHistory = null;
        }
        this.anchorElementPopup = event.target;
    }

    public closeRevHistory() {
        this.showRevHistory = false;
        this.anchorElementPopup = undefined;
    }

    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent) {
        const isClickOutsidePopup = !this.elementRef.nativeElement.contains(event.target);
        if (isClickOutsidePopup) {
            this.closeRevHistory();
        }
    }


    /**Lastviewrecords change */
    public lastviewingrecordsmethod(event: any) {
        if (event == "All") {
            this.lastViewingRecords = 0;
            this.loadscheduleDocumnets();
            this.lastViewingRecord = "All";
        }
        else {
            this.lastViewingRecords = event;
            this.lastViewingRecord = event;
            this.loadscheduleDocumnets();
        }
        this.enableFilter = false;
        this.directive.filter = undefined;
    }

    /**
     * Full screen
     */
    toggleFullscreen() {
        this.enableFullscreen = !this.enableFullscreen;
    }

    getDateFormat() {
        let today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = today.toLocaleString('default', { month: 'short' })
        var yyyy = today.getFullYear();
        let today1 = dd + '-' + mm + '-' + yyyy;
        return today1;
    }

    getDateValue(selectedText: any) {
        this.RevisedScheduleDate = selectedText.value;
    }

    async updateReviseDate() {
        this.reviseScheduleDateDetails = [];
        this.gridData.filter(x => x.isSelected).forEach(y => {
            this.reviseScheduleDateDetails.push({ docId: y.doc_Id, revisionNo: y.revision_No, stageId: y.dciScheduleStageDetails ? y.dciScheduleStageDetails[0].stage_Id : undefined });
        })
        if (this.reviseScheduleDateDetails.length > 0) {
            let inputModel: IScheduleDateUpdateDetails = {
                docSchDateDetail: this.reviseScheduleDateDetails,
                revisedDate: this.RevisedScheduleDate,
                userId: this.memberId
            };
            this.loaderService.isLoading.next(true);
            let _UpdateScheduleDateToDocuments = this._scheduleDocService.UpdateScheduleDateToDocuments(inputModel).subscribe(async (res: StandardOutputModel) => {
                if (res.successCode == 200) {
                    await this.loadscheduleDocumnets();
                    this._notificationService.showToast(res.successMessage, "Success");
                }
                else if (res.successCode == 205) {
                    this._notificationService.showToast(res.successMessage, "Warning");
                }
                this.loaderService.isLoading.next(false);
            });
            this.UnsubscribeArray.push(_UpdateScheduleDateToDocuments);
            this.dciGrid.defaultSelection.selectedKeys = [];
        }
        else {
            this._notificationService.showToast("No document is selected", "Warning");
        }
    }

    async getProjectStaticElements() {
        await this._projInfoService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
            (res: IProjectElementsOutput[]) => {
                if (res.length > 0) {
                    this.projectStaticElements = res;
                    let isDocSetRequiredElement = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
                    if (!!isDocSetRequiredElement) {
                        this.isDocSetRequired = isDocSetRequiredElement.isMandatory;
                    }
                }
            }, (err: any) => {
                this._notificationService.showToast("failed to get static element details", "Warning");
            });

    }
    public allData(): ExcelExportData {
        const result: ExcelExportData = {
            data: this.gridData.map(doc => ({
                ...doc,
                scheduled_On: doc.dciScheduleStageDetails ? (doc.dciScheduleStageDetails.filter(l => { return l.stage_Short_Desc == doc.current_Stage }).length > 0 ? formatDate(doc.dciScheduleStageDetails.filter(l => { return l.stage_Short_Desc == doc.current_Stage })[0].scheduled_On, 'dd-MMM-yyyy', 'en-US') : null) : null,
                submission_Date: doc.submission_Date ? formatDate(doc.submission_Date, 'dd-MMM-yyyy', 'en-US') : '',
                created_On: doc.created_On ? formatDate(doc.created_On, 'dd-MMM-yyyy', 'en-US') : '',
                approval_Date: doc.approval_Date ? formatDate(doc.approval_Date, 'dd-MMM-yyyy', 'en-US') : ''
            }))
        };
        return result;
    }

    public downloadTransmittalClick(data: IScheduleDocInfo) {
        if (!!data.message_Id) {
            let _GetTransmittalList = this._transmittalService.GetTransmittalList({ project_id: this.projectId, message_Id: data.message_Id }).subscribe((res: ITransmittalDetailsModel[]) => {
                if (res && res.length > 0) {
                    this.pushTransmittalTemplateModel(res[0]);
                }
            });
            this.UnsubscribeArray.push(_GetTransmittalList);
        }
    }

    pushTransmittalTemplateModel(data: ITransmittalDetailsModel) {
        this.viewTransmittalData = null;
        let groupDetails: Observable<any> = this._transmittalService.GetTransmittalGroupMemberDetails(data.message_Id);
        let docDetails: Observable<any> = this._transmittalService.GetTransmittalDocumentDetails(data.message_Id);
        let receiverDetails: Observable<any> = this._transmittalService.GetTransmittalReceiverDetails(data.message_Id);
        let _membersList: Observable<any> = this.transmittalService.getProjectMembers();
        let _pushTransmittalTemplateModel = forkJoin(groupDetails, docDetails, receiverDetails, _membersList).subscribe((res: any[]) => {
            let receiverDetails: ITransmittalMsgReceiverInput = res[2];
            let docDetails: ITransmittalDocumentInput = res[1];
            let transDocDetails: ITransmittalDocumentDetails[] = [];
            if (!!docDetails && !!docDetails.transmittalDocumentDetails) {
                transDocDetails = docDetails.transmittalDocumentDetails;
            }
            let to = receiverDetails.transmittalToDetails[0].member_Id;
            let toWithAddress;
            if (to && res[3]) {
                let toMember = res[3].filter((x: { memberId: number; }) => x.memberId == to)
                toWithAddress = (toMember[0].address) ? toMember[0].memberName + '<br>' + toMember[0].address : toMember[0].memberName
            }
            else {
                toWithAddress = receiverDetails.transmittalToDetails.map(x => x.member_Name).join(',')
            }
            let transmittalTemplate: TransmittalTemplateComponent = {
                templateName: 'common',
                projName: this.projectName,
                edrcRef: data.message_Number,
                cusRef: '',
                docDetails: transDocDetails,
                distributionDetails: res[0],
                subject: data.message_Subject,
                attention: receiverDetails.transmittalToDetails.map(x => x.member_Name).join(','),
                to: toWithAddress,
                date: formatDate(data.created_On, 'dd-MMM-yyyy', 'en-US'),
                message_No: data.message_Number,
                message_id: data.message_Id,
                cc: receiverDetails.transmittalCcDetails.map(x => x.member_Name).join(','),
                From: receiverDetails.transmittalFromDetails.map(x => x.member_Name).join(','),
                message_Note: data.message_Note
            }
            this.viewTransmittalData = transmittalTemplate;
            setTimeout(() => {
                this.loaderService.isLoading.next(true);
                this.exportToWord(data);
                this.loaderService.isLoading.next(false);
            }, 1000);
        });
        this.UnsubscribeArray.push(_pushTransmittalTemplateModel);
    }

    exportToWord(data: ITransmittalDetailsModel) {
        //To check and remove "Signed Copies" column from Work document
        let rootElement: any = document.getElementById('TransmittalComponent')?.cloneNode(true) as HTMLCanvasElement;
        let documentGrid: HTMLElement = rootElement.children[0].children["documentGrid"];
        if (documentGrid) {
            let tHead: HTMLCollection = documentGrid.children[0].children[0].children;
            if (tHead && tHead.length > 1) {
                tHead[1].remove();
            }
            for (let i = 0; i < documentGrid.children[1].children.length; i++) {
                let tBody: HTMLCollection = documentGrid.children[1].children[i].children;
                if (tBody && tBody.length > 1) {
                    tBody[1].remove();
                }
            }
        }
        let docName: string = data.message_Number;
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><style>body {margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; font-size:11px;}</style><title>Export Word Document</title></head><br><body>";
        var footer = "</body></html>";
        var html = header + rootElement.innerHTML + footer;
        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });
        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        // Specify file name
        let filename = docName + '.doc';
        // Create download link element
        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        if (blob) {
            saveAs(blob, filename);
            // return;
        }
        else {
            // Create a link to the file
            downloadLink.href = url;
            // Setting the file name
            downloadLink.download = filename;
            //triggering the function
            downloadLink.click();
        }
        document.body.removeChild(downloadLink);
    }

    public HelpUrlClick() {
        let x = JSON.parse(this._commonService.getSessionStorageItem("Menu"))
        let url = x.filter((y: { menuDesc: string; }) => y.menuDesc == "Schedule Documents")[0].helpUrl
        if (url) {
            window.open(url);
        }
    }

    ngOnDestroy(): void {
        this.UnsubscribeArray.forEach(x => x.unsubscribe());
    }
    getStartDateValue(selectedText) {
        this.start = selectedText;

    }
    getEndDateValue(selectedText) {
        this.end = selectedText;

    }
    selectedScheduleType(value: any) {
        let docdata
        if (value && value.emittingList)
            docdata = value.emittingList.map((x: {
                value: any;
            }) => +x.value);

        if (docdata && docdata.length > 0)
            this.Doc_typeid = docdata;
        else
            this.Doc_typeid = null;
    }

    selectedStage(value: any) {
        if (value.value != "-2") {
            this.stages = value.additionalValues.additionalValues.dedId;
        } else {
            this.stages = null;
        }
    }
    search() {
        let resForm: FormGroup | undefined | null = this.dynamicForm.form;
        let elementInp: IProjectElementDetailsOutput[] = this.projectElements.map(x => {
            let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription).value;
            if (selectedValue == null) {
                return null;
            } else {
                let result: IProjectElementDetailsOutput = {
                    deId: x.elementId,
                    dedId: selectedValue.dedId,
                    deDescription: x.elementDescription,
                    dedDescription: selectedValue.dedDescription,
                    dedShortDescription: selectedValue.dedShortDescription,
                    sortBy: +selectedValue.sortBy
                };
                return result;
            }
        }).filter(x => x !== null) as IProjectElementDetailsOutput[];

        let inputModel: IPorjectInputModel = {
            project_Id: this.projectId
            , group_Id: this.groupId
            , stages: this.stages
            , transmittal_no: this.searchForm.get('ctrlTransNo').value
            , schedule_Type: this.Doc_typeid?.join(',')
            , docNo: this.searchForm.get('ctrlDocNo').value
            , schedule_from: this.datepipe.transform(this.start, "yyyy-MM-dd")
            , schedule_to: this.datepipe.transform(this.end, "yyyy-MM-dd")
            , projDynamicElements: JSON.stringify(elementInp)
        };
        this.loadscheduleDocumnets(inputModel)
    }
}